import { Button } from "./UiComponents/button";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  Id,
  TextMessage,
  isGreen,
  abbrCancel,
  abbrConfirm
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (Id: string) => void;
  Id?: string;
  TextMessage: string;
  isGreen?: boolean;
  abbrCancel?: string;
  abbrConfirm?: string;
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(Id || '');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-sm w-full mx-4 relative z-50">
        <h2 className="text-xl font-semibold mb-4 dark:text-white">Confirm action</h2>
        <p className="mb-6 dark:text-gray-300">{TextMessage}</p>
        <div className="flex justify-start gap-3">
          <Button
            abbr={abbrCancel ?? "Cancel this action"}
            onClick={onClose}
            variant="outline"
          >
            Cancel
          </Button>
          <Button
            abbr={abbrConfirm ?? "Confirm this action"}
            onClick={handleConfirm}
            variant={isGreen ? "default" : "destructive"}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
